/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-11-23 19:08:06
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2025-02-22 20:39:59
 * @FilePath: \szsc_ipark_device_admin(contractadmin)\src\area-dcits\api\workflow.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https:// github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import http from '@/api/base'

let str = '/workflow-engine'
// 根据流程key查询发布的流程信息
const workflowPubulic = (key, params) => {
  params.platformFlag = true
  return http.post(str + '/model-publishs/' + key, params)
}

// 获取下一阶段提交信息
const workflowNext = (params) => {
  let thisparam = {}
  thisparam.platformFlag = true
  return http.post(str + '/activity/next-activities?' + params, thisparam)
}

/**
 * 平安获取权限
 */
const selectAppovingDetailByPid = (params) => {
  let thisparam = {}
  thisparam.platformFlag = true
  return http.post(str + '/pingAnProcject/selectAppovingDetailByPid?' + params, thisparam)
}

// 平安办理过程跟踪（包含已执行节点和未执行节点）
const getTaskNodeList = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/getTaskNodeList', params)
}

// 发起流程兼自动审批（后台判断流程是否已经发布，未发布流程执行自动审批）
const workflowStart = (operType, procDefKey, procInstId, params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/autoApproval?operationType=' + operType + '&processDefinitionId=' + procInstId + '&processDefinitionKey=' + procDefKey, params)
}

// 提交流程
const workflowHandle = (params) => {
  params.platformFlag = true
  return http.post(str + '/start-process', params)
}

// 退回流程
const workflowBack = (params) => {
  params.platformFlag = true
  return http.post(str + '/back-process', params)
}

// 直接提交流程
const submitNoChoose = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/submitNoChoose', params)
}

// 提交附言/转交
const addTaskComment = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/addTaskComment', params)
}

// 驳回节点查询-平安直接获取驳回节点，不获取驳回人
const canRejectNodes = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/canRejectNodes', params)
}

// 驳回
const rejectNode = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/reject', params)
}

// 重新发起
const getRestartSubmit = (params) => {
  let thisparam = {}
  thisparam.platformFlag = true
  return http.post(str + '/pingAnProcject/getRestartSubmit?' + params, thisparam)
}

// 附件上传
const saveAttachent = (userId, params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/saveAttachent?userId=' + userId, params)
}

// 校验待办任务是否可以提交_改为post请求，因为get请求在base.js中分发时无法获取对应分发参数
const beforeCheckTask = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/beforeCheckTask', params)
}
// 受理接口
const subTaskObj = (taskId, params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/runtimeBefore?taskId=' + taskId, params)
}

// 转交接口
const transferAssginee = (params) => {
  params.platformFlag = true
  return http.post(str + '/pingAnProcject/transferAssginee', params)
}

// 校验当前六次是否为最新流程接口_用于重新发起时校验
const checkDef = (params) => {
  let thisparam = {}
  thisparam.platformFlag = true
  return http.post(str + '/wfModelVersions/checkDefId?defId=' + params, thisparam)
}

export default {
  workflowPubulic,
  getTaskNodeList,
  selectAppovingDetailByPid,
  workflowNext,
  workflowStart,
  workflowHandle,
  workflowBack,
  submitNoChoose,
  addTaskComment,
  canRejectNodes,
  rejectNode,
  getRestartSubmit,
  saveAttachent,
  beforeCheckTask,
  subTaskObj,
  transferAssginee,
  checkDef
}



// WEBPACK FOOTER //
// ./src/area-dcits/api/workflow.js